import React from "react";
import { useRecoilState } from "recoil";
import { Icon, Menu } from "semantic-ui-react";

import { lyricsActive } from "./atoms";

import { options$ } from "./OptionsStream";
import { useIsMobile } from "./utils";

export function ShowLyricsToggle({showLabel = false}) {
  const isMobileDevice = useIsMobile();
  const [lyrics, setLyrics] = useRecoilState(lyricsActive);

  const active = isMobileDevice ? lyrics : undefined;
  const color = lyrics ? "blue" : undefined;

  return (
    <Menu.Item
      name="lyrics"
      active={active}
      onClick={() => {
        setLyrics(!lyrics);
        options$.lyricsActive(!lyrics);
      }}
    >
      <>
        <Icon.Group size="large">
          <Icon id="lyrics" name="music" color={color} />
          <Icon corner name="bars" color={color} />
        </Icon.Group>
        {(isMobileDevice || showLabel) && (
          <>
            <br />
            Lyrics
          </>
        )}
      </>
    </Menu.Item>
  );
}
